/**
 * 角色管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getMenuList(keyId = '') {
		return request(api.comm.MENU + `?parentId=${keyId}`, METHOD.GET);
	},
	async getDeptList() {
		return request(api.comm.DEPT, METHOD.GET);
	},
	async getFormDetail(keyId) {
		return request(api.comm.ROLE + "/" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.ROLE, METHOD.POST, result);
	},

}


export default {dataApi}